module.exports = __webpack_public_path__ + "static/media/18e670c8-7fb4-481b-818e-173bbaa057f6.3a49d35d.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/18e670c8-7fb4-481b-818e-173bbaa057f6.jpg
// module id = 803
// module chunks = 0